import axios from "axios";

export const LOGIN_URL = "https://university.auanet.org/mobileapps/admin/login/main.cfc?method=remoteLogin"
export const MAIN_URL = "https://university.auanet.org/mobileapps/admin/auauniversity/main.cfc"

export const LOGIN_AXIOS = () => {
    return axios.create({
        baseURL: LOGIN_URL,
        timeout: 10000000000000
    });
};

export const BASE_AXIOS = () => {
    return axios.create({
        baseURL: MAIN_URL,
        timeout: 10000000000
    });
};

export const ETHOS_AXIOS = () => {
    return axios.create({
        baseURL: MAIN_URL,
        timeout: 10000000000000
    });
};